import React, { useState } from 'react';
import '../CSS/Gallery.css';
import { Button } from 'primereact/button';

interface GalleryProps {
    images: string[];
    isEditing: boolean;
    onImageUpload?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onImageRemove?: (index: number) => void;
}

const Gallery: React.FC<GalleryProps> = ({ images, isEditing, onImageUpload, onImageRemove }) => {
    const displayImages = images.slice(0, 10);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    const handleImageClick = (img: string) => {
        setSelectedImage(img);
    };

    const handleCloseModal = () => {
        setSelectedImage(null);
    };

    return (
        <div className="gallery-container">
            <div className="gallery-grid">
                {displayImages.map((img, index) => (
                    <div key={index} className="gallery-item">
                        <img
                            src={img}
                            alt={`Gallery image ${index + 1}`}
                            className="w-full h-full object-cover rounded-lg"
                            onClick={() => handleImageClick(img)}
                        />
                        {isEditing && onImageRemove && (
                            <Button
                                icon="pi pi-times"
                                className="p-button-rounded p-button-danger p-button-sm absolute top-2 right-2"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onImageRemove(index);
                                }}
                                aria-label="Remove image"
                            />
                        )}
                    </div>
                ))}
                {isEditing && onImageUpload && (
                    <div className="gallery-upload-container">
                        <label htmlFor="gallery-upload" className="upload-label cursor-pointer">
                            <i className="pi pi-plus"></i>
                            <span>Add Image</span>
                        </label>
                        <input
                            type="file"
                            id="gallery-upload"
                            accept="image/*"
                            onChange={onImageUpload}
                            style={{ display: 'none' }}
                            multiple
                        />
                    </div>
                )}
            </div>

            {selectedImage && (
                <div className="modal-overlay" onClick={handleCloseModal}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <img src={selectedImage} alt="Full size" className="modal-image" />
                        <button className="modal-close" onClick={handleCloseModal}>×</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Gallery;